(function () {
  // ✅ 你自己的 Files 基础路径（保留到 /files/ 结尾）
  const FILES_BASE = "https://cdn.shopify.com/s/files/1/0902/3517/5292/files/";
  const EXT = "png"; // jpg 就写 "jpg"

  // ✅ 只处理第2组：0=第一组，1=第二组，2=第三组...
  const TARGET_GROUP_INDEX = 1;

  // ---------- utils ----------
  function getItemText(itemEl) {
    const textEl =
      itemEl.querySelector(
        ".color-swatch__title, .swatch__label, .variant__label, .color-swatch__text"
      ) || null;

    if (textEl && textEl.textContent) return textEl.textContent.trim();

    const aria = itemEl.getAttribute("aria-label") || itemEl.getAttribute("title");
    if (aria) return aria.trim();

    return (itemEl.textContent || "").trim();
  }

  function normalizeName(str) {
    if (!str) return "";
    let s = String(str).trim();
    s = s.replace(/×/g, "x");
    s = s.replace(/["“”′’]/g, "");
    s = s.replace(/[^0-9a-zA-Z_-]/g, "");
    return s;
  }

  function buildCandidates(text) {
    const raw = String(text || "").trim();
    const a = normalizeName(raw);
    const b = normalizeName(raw.replace(/\s+/g, "_"));
    const c = a ? a.toLowerCase() : "";
    const d = b ? b.toLowerCase() : "";

    const fixTypo = (x) => (x ? x.replace(/digtal/gi, "digital") : "");
    const e = fixTypo(a);
    const f = fixTypo(b);
    const g = fixTypo(c);
    const h = fixTypo(d);

    const noUnderscore = (x) => (x ? x.replace(/_/g, "") : "");
    const i = noUnderscore(e);
    const j = noUnderscore(f);
    const k = noUnderscore(g);
    const l = noUnderscore(h);

    const arr = [a, b, c, d, e, f, g, h, i, j, k, l].filter(Boolean);
    return Array.from(new Set(arr));
  }

  function getSwatchGroups() {
    return Array.from(document.querySelectorAll(".color-swatches-container"));
  }

  function getSwatchItems(groupEl) {
    return Array.from(groupEl.querySelectorAll("label.color-swatch, .color-swatch"));
  }

  /**
   * ✅ 关键：不改原 img.src，不把 img hidden 掉
   * ✅ 用 overlay 层显示 Files 图片，且 overlay pointer-events:none，点击能穿透
   */
  function applyImageToSwatch(itemEl, url) {
    const img =
      itemEl.querySelector("img") ||
      itemEl.querySelector(".color-swatch__image img") ||
      null;

    // 保留主题原图，但让它“看不见”
    if (img) {
      if (!img.getAttribute("data-original-src")) {
        img.setAttribute("data-original-src", img.getAttribute("src") || "");
      }
      img.style.opacity = "0";          // ✅ 可点、可被事件捕获
      img.style.visibility = "visible"; // ✅ 千万别 hidden
      img.style.pointerEvents = "auto"; // ✅ 保证能被点到（有些主题会改）
    }

    // 找一个承载盒子：优先 .color-swatch__image
    const host =
      itemEl.querySelector(".color-swatch__image") ||
      itemEl.querySelector(".color-swatch__custom-color") ||
      itemEl.querySelector(".color-swatch__value") ||
      itemEl;

    if (!host) return;

    // 确保 host 可放绝对定位 overlay
    const cs = window.getComputedStyle(host);
    if (cs.position === "static") host.style.position = "relative";

    // 创建 / 更新 overlay
    let overlay = host.querySelector(":scope > .files-swatch-overlay");
    if (!overlay) {
      overlay = document.createElement("span");
      overlay.className = "files-swatch-overlay";
      overlay.setAttribute("aria-hidden", "true");

      // 样式写内联，避免你还要配 css
      overlay.style.position = "absolute";
      overlay.style.inset = "0";
      overlay.style.backgroundSize = "cover";
      overlay.style.backgroundPosition = "center";
      overlay.style.backgroundRepeat = "no-repeat";
      overlay.style.pointerEvents = "none"; // ✅ 点击穿透
      overlay.style.borderRadius = "inherit";

      host.appendChild(overlay);
    }

    overlay.style.backgroundImage = `url("${url}")`;
  }

  function setSwatchFromFiles(itemEl, candidates) {
    if (!FILES_BASE) return;
    if (!candidates || !candidates.length) return;

    // ✅ 去重：同一个 item 同一组候选只跑一次
    const key = candidates.join("|");
    if (itemEl.getAttribute("data-files-key") === key) return;
    itemEl.setAttribute("data-files-key", key);

    let idx = 0;

    const tryNext = () => {
      if (idx >= candidates.length) return;
      const name = candidates[idx++];
      const url = `${FILES_BASE}${name}.${EXT}`;

      const probe = new Image();
      probe.onload = function () {
        applyImageToSwatch(itemEl, url);
      };
      probe.onerror = function () {
        tryNext();
      };
      probe.src = url;
    };

    tryNext();
  }

  // ---------- core ----------
  function applySecondGroup() {
    const groups = getSwatchGroups();
    if (!groups.length) return;

    const groupEl = groups[TARGET_GROUP_INDEX];
    if (!groupEl) return;

    const items = getSwatchItems(groupEl);
    if (!items.length) return;

    items.forEach((itemEl) => {
      const text = getItemText(itemEl);
      if (!text) return;

      const candidates = buildCandidates(text);
      setSwatchFromFiles(itemEl, candidates);
    });
  }

  // ✅ 防抖：避免频繁重渲染导致重复跑
  let t = null;
  function applyDebounced() {
    clearTimeout(t);
    t = setTimeout(applySecondGroup, 60);
  }

  // 初次加载
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyDebounced);
  } else {
    applyDebounced();
  }

  // DOM更新时自动补（不依赖点击）
  const mo = new MutationObserver(() => applyDebounced());
  mo.observe(document.documentElement, { childList: true, subtree: true });

  // 变体 change 也补一次
  document.addEventListener(
    "change",
    (e) => {
      const el = e.target;
      if (!el) return;
      if (el.matches('input[type="radio"], select')) applyDebounced();
    },
    true
  );
})();
